import React from 'react';
import { MONTHS } from './constants';
import { Button } from '@codeparva/ui-components-library';
import { Icon } from '../../../../utilities/icomoon-css';
import { navigate } from 'gatsby';
import { accountSectionConfig } from '../../../userFlows/components/accountConfig';

interface IProps {
  data: any;
  formatterProps?: any;
}

export const dateFormatter = ({ data }: IProps) => {
  const dateParts = data.split('-');
  const year = dateParts[0];
  const month = dateParts[1];
  const day = dateParts[2];

  const monthAbbreviation = MONTHS[parseInt(month) - 1];

  let daySuffix;
  if (day === '01' || day === '21' || day === '31') {
    daySuffix = 'st';
  } else if (day === '02' || day === '22') {
    daySuffix = 'nd';
  } else if (day === '03' || day === '23') {
    daySuffix = 'rd';
  } else {
    daySuffix = 'th';
  }

  const formattedDate = `${parseInt(
    day
  )}${daySuffix} ${monthAbbreviation} ${year}`;

  return formattedDate;
};

export const actionFormatter = ({ data, formatterProps }: IProps) => {
  const { ledgerId: ledgerIdFromReservation, apiRes } = formatterProps || {};
  const { unitTypeId, reservationId } = data || {};
  const {
    data: { unitTypeData = [] } = {},
    facilityName,
    locationStrapiId,
    locationState,
    locationCity,
    data: unitsData,
  } = apiRes || {};
  const currentUnitTypeData = unitTypeData.find(
    (unitType: any) => unitType.unitTypeID === unitTypeId
  );
  const {
    vacantUnitsCount: { total_count: vacantUnitCount = 0 } = {},
    tfw: { move_in: { is_enabled: isMoveInEnabled = false } = {} } = {},
  } = currentUnitTypeData || {};
  const label = data['label'];

  const handleMoveInClick = () => {
    let relativePath = '';
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    if (urlParts[3] === 'account') {
      relativePath = `../../../${locationState}/${locationCity}/view-rates/move-in`;
    } else {
      relativePath = '../../../view-rates/move-in';
    }
    !!apiRes &&
      navigate(relativePath, {
        state: {
          source: 'navigateMoveIn',
          clickedPath: 'move-in',
          locationStrapiId,
          facilityName,
          ledgerIdFromReservation,
          individualUnitTypeData: { ...currentUnitTypeData },
          unitsData,
          reservationId,
        },
        replace: true,
      });
  };

  return (
    <>
      {currentUnitTypeData && isMoveInEnabled && vacantUnitCount ? (
        <Button
          className={apiRes ? 'actionButton' : 'actionButtonDisabled'}
          onClick={handleMoveInClick}
          disabled={!apiRes}
        >
          <div className="actionButtonInnerEnclosure">
            <span>{label}</span>
            <Icon
              name={'tfw-arrow-right-cp'}
              size={24}
              title={'tfw-arrow-right-cp'}
              color="secondary"
            />
          </div>
        </Button>
      ) : (
        <div>{accountSectionConfig.callFacility}</div>
      )}
    </>
  );
};

export const reservationCodeFormatter = ({ data }: IProps) => {
  return <span className="reservationCode">{data}</span>;
};
